import { Vector3 } from '@babylonjs/core/Maths/math.vector';

export const sgSampleProjectProperties = {
	desktop: {
		outdoorProject: [
			[
				{
					position: new Vector3(-0.0056733726523816586, -0.19751286506652832, 3.7152767181396484),
					scaling: new Vector3(2.9251092011295796, 3.1190309732483064, 0.14793586706053982),
					rotation: new Vector3(0.03571807890953193, 0.643254348509487, -0.02401562624178444),
					cameraRadius: 7.222238997592502,
				},
				{
					position: new Vector3(0.01844271831214428, -0.13226594030857086, 1.2839598655700684),
					scaling: new Vector3(5.992705956479908, 3.1688511693790757, 0.14793577943548),
					rotation: new Vector3(0.013404360766622705, 2.5092447440536243, 0.032002902935201125),
					cameraRadius: 6.098416257058496,
				},
				{
					position: new Vector3(0.5640469193458557, 0.0031419587321579456, -1.0435458421707153),
					scaling: new Vector3(2.3791297351586, 3.1963066790154766, 0.14793600670522292),
					rotation: new Vector3(0.020406011035009265, 2.492852292502813, 0.0382536734239474),
					cameraRadius: 2.460116778461561,
				},
			],
			[
				{
					position: new Vector3(-0.025237437337636948, 0.03945312276482582, -0.11802776157855988),
					scaling: new Vector3(4.796420574188232, 3.6568429470062256, 0.14793577790260315),
					rotation: new Vector3(-1.389658758909268e-22, 1.5707963267948963, 1.2246454629217388e-16),
					cameraRadius: 4.619649664615295,
				},
				{
					position: new Vector3(0.6777396202087402, 0.03859958425164223, 2.0002501010894775),
					scaling: new Vector3(1.3155610216088647, 3.457371950149536, 0.14793931879697736),
					rotation: new Vector3(0, -0.03565680621102791, 0),
					cameraRadius: 3.077994581441281,
				},
				{
					position: new Vector3(0.21986575424671173, 0.05121638998389244, -2.1782774925231934),
					scaling: new Vector3(1.3887884542460498, 3.453505754470825, 0.14793592162169938),
					rotation: new Vector3(-0, -3.0410965278719457, 0),
					cameraRadius: 3.498698674529169,
				},
			],
			[
				{
					position: new Vector3(-0.24117976427078247, 0.044031474739313126, -2.300901412963867),
					scaling: new Vector3(2.9326583289894197, 3.2853082584614612, 0.14793598869748495),
					rotation: new Vector3(0.010610095539797982, 2.4263581005556607, 0.008000412561650462),
					cameraRadius: 10.020176758196989,
				},
				{
					position: new Vector3(0.024936910718679428, 0.09079047292470932, -0.1504308581352234),
					scaling: new Vector3(5.169240304468603, 3.6879912604858305, 0.14793579233632592),
					rotation: new Vector3(0.002910535461123495, 0.45615103628961995, -0.007000005739653548),
					cameraRadius: 9.859293185895629,
				},
				{
					position: new Vector3(0.02104070968925953, 0.12878857553005219, 1.6695775985717773),
					scaling: new Vector3(3.6622233359935428, 3.6807809345048685, 0.14793576681198484),
					rotation: new Vector3(0.005465974782985341, 0.4529957572906832, -0.012000238849089635),
					cameraRadius: 6.134105508849938,
				},
			],
		],
		interiorProject: [
			[
				{
					position: new Vector3(0.005649822764098644, 0.584529459476471, 1.2168729305267334),
					scaling: new Vector3(3.5829326596604494, 2.4067563892608357, 0.10865944608646583),
					rotation: new Vector3(-0.0011694809954081694, 1.2908692776325765, 0.0010000006045405492),
					cameraRadius: 7.3358472570748265,
				},
			],
			[
				{
					position: new Vector3(0.00974777527153492, 0.8499879004089294, 1.8685110388728283),
					scaling: new Vector3(3.990909781217006, 2.634726898500563, 0.10865944038429663),
					rotation: new Vector3(-0.0017611083707866314, 1.1962901526570495, 0.005269583841604782),
					cameraRadius: 6.325468281784149,
				},
			],
			[
				{
					position: new Vector3(-2.7037333035387894e-18, 1.0821589615331402, 0.010616455881759735),
					scaling: new Vector3(2.5069878101348877, 2.284780263900757, 0.10865944623947144),
					rotation: new Vector3(4.1689918021267165e-22, 1.5707963267948961, 1.2247230855504205e-16),
					cameraRadius: 6.819315582999615,
				},
			],
		],
	},
	mobile: {
		outdoorProject: [
			[
				{
					position: new Vector3(0.034134406596422195, -0.20384149253368378, 3.685150146484375),
					scaling: new Vector3(3.025240722916791, 3.247891088733894, 0.1479358551616389),
					rotation: new Vector3(0.03571808273362363, 0.6432543875626946, -0.02401566304928653),
					cameraRadius: 7.222238997592502,
				},
				{
					position: new Vector3(-0.023103639483451843, -0.14829300343990326, 1.2537847757339478),
					scaling: new Vector3(6.094324585929805, 3.2544413107527883, 0.14793580863917669),
					rotation: new Vector3(0.013404352182217775, 2.5092443680497136, 0.03200294689997101),
					cameraRadius: 6.098416257058496,
				},
				{
					position: new Vector3(0.6096616983413696, -0.017904173582792282, -1.0084171295166016),
					scaling: new Vector3(2.4957976890912827, 3.286454707673741, 0.14793584238088264),
					rotation: new Vector3(0.020405963977670007, 2.4928525897995573, 0.03825362176751694),
					cameraRadius: 2.460116778461561,
				},
			],
			[
				{
					position: new Vector3(-0.025237437337636948, 0.04914231598377228, -0.12173853069543839),
					scaling: new Vector3(4.99269962310791, 3.769679069519043, 0.14793577790260315),
					rotation: new Vector3(-3.1101915300114344e-22, 1.5707963267948963, 1.2246446026539017e-16),
					cameraRadius: 4.619649664615295,
				},
				{
					position: new Vector3(0.6834682822227478, 0.047862183302640915, 2.000462055206299),
					scaling: new Vector3(1.527212177060706, 3.5981292724609375, 0.1479393638704575),
					rotation: new Vector3(0, -0.035656871403607675, 0),
					cameraRadius: 3.077994581441281,
				},
				{
					position: new Vector3(0.3098040819168091, 0.05813128501176834, -2.1884818077087402),
					scaling: new Vector3(1.5698498382977437, 3.595508575439453, 0.147936045543675),
					rotation: new Vector3(-0, -3.027279779391353, 0),
					cameraRadius: 3.498698674529169,
				},
			],
			[
				{
					position: new Vector3(-0.233664408326149, 0.06946909427642822, -2.2947328090667725),
					scaling: new Vector3(3.148976539917546, 3.536506316707636, 0.14793607510955145),
					rotation: new Vector3(0.010610088367950668, 2.426359794250255, 0.008000424844181418),
					cameraRadius: 10.020176758196989,
				},
				{
					position: new Vector3(-0.026677925139665604, 0.12872587144374847, -0.12498369067907333),
					scaling: new Vector3(5.284867256236541, 3.9383982845854644, 0.14793580646154697),
					rotation: new Vector3(0.0029105312808500312, 0.45615032633331565, -0.007000028917386571),
					cameraRadius: 9.859293185895629,
				},
				{
					position: new Vector3(0.017727602273225784, 0.16207268834114075, 1.6713935136795044),
					scaling: new Vector3(3.869136475899591, 3.937693090926796, 0.14793576645962606),
					rotation: new Vector3(0.005465977730125133, 0.4529959715767598, -0.012000248478722953),
					cameraRadius: 6.134105508849938,
				},
			],
		],
		interiorProject: [
			[
				{
					position: new Vector3(0.02056461200118065, 0.555512547492981, 1.1651129722595215),
					scaling: new Vector3(3.6251820326353283, 2.4648955438557034, 0.10865944660124055),
					rotation: new Vector3(-0.0011694822002236488, 1.2908692776334114, 0.0009999981466413022),
					cameraRadius: 6.924086320049875,
				},
			],
			[
				{
					position: new Vector3(0.04445743188261986, 0.8004539012908936, 1.78043794631958),
					scaling: new Vector3(3.9301573699343866, 2.620018629275751, 0.10865944038437352),
					rotation: new Vector3(-0.0017611085900893022, 1.196290162814627, 0.005269579142149317),
					cameraRadius: 5.913707344759197,
				},
			],
			[
				{
					position: new Vector3(-5.168525560974286e-18, 1.0892162322998047, 0.016166260465979576),
					scaling: new Vector3(2.667198657989502, 2.4406015872955322, 0.10865944623947144),
					rotation: new Vector3(2.580804647371669e-22, 1.5707963267948961, 1.2247221591082607e-16),
					cameraRadius: 6.710124486815381,
				},
			],
		],
	},
	mobile_portrait: {
		outdoorProject: [
			[
				{
					position: new Vector3(0.2430465966463089, -0.2403518557548523, 1.2364630699157715),
					scaling: new Vector3(2.448293957945822, 3.4586731662791186, 0.1479357493372038),
					rotation: new Vector3(0.02483963039299928, 0.7934310793210856, -0.021006302942144593),
					cameraRadius: 7.933723174110167,
				},
				{
					position: new Vector3(-0.32137179374694824, -0.17778849601745605, -0.37580981850624084),
					scaling: new Vector3(4.8556428065552675, 3.4807476516676323, 0.14793576481911422),
					rotation: new Vector3(0.015471765948824635, 2.717647201963788, 0.03600432571033402),
					cameraRadius: 7.251793248090403,
				},
			],
			[
				{
					position: new Vector3(6.599262292183994e-7, 0.11674108356237411, -0.0046090236864984035),
					scaling: new Vector3(2.5236023693484086, 3.403052429594886, 0.147935777907878),
					rotation: new Vector3(-1.429268249597293e-7, 1.5707878833346536, -0.003027599277916695),
					cameraRadius: 3.913633585993011,
				},
			],
			[
				{
					position: new Vector3(0.038166314363479614, 0.022672850638628006, 0.9783698916435242),
					scaling: new Vector3(4.549934709444878, 3.4858445002037137, 0.1479357691448577),
					rotation: new Vector3(-0.002800261931602038, 0.3317396721382289, -0.007000026228830019),
					cameraRadius: 8.280090550469124,
				},
				{
					position: new Vector3(0.014703675173223019, 0.006835023406893015, -0.9730417132377625),
					scaling: new Vector3(3.4629287643020974, 3.699694348688011, 0.14793578306934874),
					rotation: new Vector3(0.007282462191986389, 2.357470130784131, 0.006000157809776409),
					cameraRadius: 9.895103309586228,
				},
			],
		],
		interiorProject: [
			[
				{
					position: new Vector3(0.010248196311295033, 0.5134342312812805, 0.05203309282660484),
					scaling: new Vector3(3.8827514761742115, 2.489383832089167, 0.10865948177377005),
					rotation: new Vector3(0.009719375754109135, 1.1984379908819314, 0.0002754978817906937),
					cameraRadius: 10.639068881140613,
				},
			],
			[
				{
					position: new Vector3(0.013111406937241554, 0.7773376107215881, 0.49828845262527466),
					scaling: new Vector3(4.529367880976905, 2.5402072298824425, 0.10865944091701665),
					rotation: new Vector3(-0.01747987159607498, 0.9765657315333311, 0.011001672408866259),
					cameraRadius: 10.21598735307324,
				},
			],
			[
				{
					position: new Vector3(0.001452987315133214, 0.9144092798233032, 0.0045411111786961555),
					scaling: new Vector3(2.335487815086721, 2.114836708065077, 0.10865949429276975),
					rotation: new Vector3(-0.005661329022085842, 1.5237979273006241, 0.0029999971888566585),
					cameraRadius: 10.120836150754373,
				},
			],
		],
	},
};
